import { render, staticRenderFns } from "./StaticInfoAdd.vue?vue&type=template&id=22173362&scoped=true"
import script from "./StaticInfoAdd.vue?vue&type=script&lang=js"
export * from "./StaticInfoAdd.vue?vue&type=script&lang=js"
import style0 from "./StaticInfoAdd.vue?vue&type=style&index=0&id=22173362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22173362",
  null
  
)

export default component.exports